<template>
  <v-row
    dense
    align="center"
    justify="end"
  >
    <v-col cols="auto">
      <authorization
        permissionKey="move_medical_request_on_workflow"
        can="action"
        v-slot:default="{ authorization }"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              icon
              :disabled="disabled || !authorization"
              :attrs="attrs"
              v-on="on"
              v-if="allowBackToWaitingStatus"
              @click="backToWaitingStatus(currentWorkflowStatus)"
            >
              <v-icon>ri-restart-line</v-icon>
            </v-btn>
          </template>

          <span> Voltar para aguardando execução </span>
        </v-tooltip>
      </authorization>
    </v-col>

    <v-col cols="auto">
      <authorization
        permissionKey="move_medical_request_on_workflow"
        can="action"
        v-slot:default="{ authorization }"
      >
        <MedicalRequestNextWorkflow
          v-if="authorization"
          :nextWorkflowStatus="nextWorkflowStatus"
          :changeStatus="changeStatus"
          :disabled="disabled"
          v-slot:default="{ clickEvent, on, attrs, disabled }"
        >
          <v-btn
            small
            icon
            :attrs="attrs"
            v-on="on"
            @click.stop="clickEvent"
            :disabled="disabled"
          >
            <v-icon>eva-arrowhead-right-outline</v-icon>
          </v-btn>
        </MedicalRequestNextWorkflow>
      </authorization>
    </v-col>

    <v-col cols="auto">
      <authorization
        permissionKey="move_medical_request_on_workflow"
        can="action"
        v-slot:default="{ authorization }"
      >
        <EditMedicalRequestButton
          v-if="authorization"
          :medicalRequest="medicalRequest"
        />
      </authorization>
    </v-col>

    <v-col
      cols="auto"
      v-if="showExecuteBtn"
    >
      <authorization
        permissionKey="attendance_medical_request"
        can="action"
        v-slot:default="{ authorization }"
      >
        <v-tooltip
          left
          v-if="authorization"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              icon
              :attrs="attrs"
              v-on="on"
              @click="executeMedicalRequest"
              :disabled="disabled"
            >
              <v-icon>ri-flask-line</v-icon>
            </v-btn>
          </template>

          <span> Realizar exame </span>
        </v-tooltip>
      </authorization>
    </v-col>
  </v-row>
</template>

<script>
import CHANGE_WORKFLOW_STATUS from "@/graphql/medical_request/change_workflow_status.gql";
import EXECUTE_EXAM_REQUEST from "@/graphql/medical_request/execute_medical_request.gql";
import BACK_TO_WAITING_STATUS from "@/graphql/medical_request/back_to_waiting_execution_status.gql"

import MedicalRequestNextWorkflow from "@/components/medical_request/list/item/next_workflow.vue";
import EditMedicalRequestButton from "@/components/medical_request/list/item/edit_medical_request_button.vue";

export default {
  name: "MedicalRequestWorkflowMoviment",
  props: {
    medicalRequest: Object,
    attendance: Object,
    showExecuteBtn: {
      type: Boolean,
      default: true
    },
    refreshQueue: {
      type: Function,
      default: () => { },
    },
    refreshMedicalRequest: {
      type: Function,
      default: () => { },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MedicalRequestNextWorkflow,
    EditMedicalRequestButton,
  },
  computed: {
    allowBackToWaitingStatus() {
      return this.currentWorkflowStatus.name === "Aguardando execução (Medico)" ||
        this.currentWorkflowStatus.name === "Executando por médico" ||
        this.currentWorkflowStatus.name === "Executando"
    },
    permittedWorkflowStatuses() {
      return this.medicalRequest.permittedWorkflowStatuses;
    },
    currentWorkflowStatus() {
      return this.medicalRequest.currentWorkflowStatus;
    },
    nextWorkflowStatuses() {
      return this.permittedWorkflowStatuses;
    },
    nextWorkflowStatus() {
      if (this.currentWorkflowStatus) {
        const nextStatuses = this.currentWorkflowStatus.nextStatuses;
        return this.lodash.intersectionBy(
          this.nextWorkflowStatuses,
          nextStatuses,
          "id"
        );
      }

      return this.lodash.filter(this.nextWorkflowStatuses, (e) => e.initial);
    },
  },
  methods: {
    executeMedicalRequest() {
      if (this.disabled) return;

      if (confirm("⚠️ Deseja REALIZAR o exame?⚠️   obs: Não será possível alterar seu status.")) {
        this.apolloMutate({
          mutation: EXECUTE_EXAM_REQUEST,
          variables: {
            attendanceId: this.attendance.id,
            medicalRequestId: this.medicalRequest.id,
          },
        }).then(({ data }) => {
          const medicalId = data.executeMedicalRequest;
          const medicalRequestId = this.medicalRequest.id

          if (this.medicalRequest.medicalRequestType === "exam") {
            this.$router.push({
              path: `/prontuario/${this.attendance.id}/exames/${medicalId}/solicitacao/${medicalRequestId}`,
              query: { redirectTo: this.$route.fullPath },
            });
          }

          if (this.medicalRequest.medicalRequestType === "treatment") {
            this.$router.push({
              path: `/prontuario/${this.attendance.id}/tratamentos/${medicalId}/solicitacao/${medicalRequestId}`,
              query: { redirectTo: this.$route.fullPath },
            });
          }
        });

      }
    },
    changeStatus(workflow_status) {
      if (this.disabled) return;

      this.apolloMutate({
        mutation: CHANGE_WORKFLOW_STATUS,
        variables: {
          medicalRequestId: this.medicalRequest.id,
          workflowStatusId: workflow_status.id,
        },
      })
        .then(() => {
          this.$store.dispatch("createNotification", {
            message: `Solicitação de exame movida para ${workflow_status.name}`,
            type: "success",
          });

          this.refreshQueue();
          this.refreshMedicalRequest();
        })
        .catch((error) => {
          const errorMessage = error.message.replace("GraphQL error: ", "");

          this.$store.dispatch("createNotification", {
            message: errorMessage,
            type: "error",
          });
        });
    },
    backToWaitingStatus(workflow_status) {
      if (this.disabled) return;

      this.apolloMutate({
        mutation: BACK_TO_WAITING_STATUS,
        variables: {
          medicalRequestId: this.medicalRequest.id,
          workflowStatusId: workflow_status.id,
        },
      })
        .then(() => {
          this.$store.dispatch("createNotification", {
            message: `Solicitação de exame movida para ${workflow_status.name}`,
            type: "success",
          });

          this.refreshQueue();
          this.refreshMedicalRequest();
        })
        .catch((error) => {
          const errorMessage = error.message.replace("GraphQL error: ", "");

          this.$store.dispatch("createNotification", {
            message: errorMessage,
            type: "error",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
